import {customElement} from "lit/decorators.js";
import {resolve} from "../../container";
import {Section, SECTION_BACKGROUND_CLASS_PREFIX, Sections} from "./sections";
import {ManagingResources} from "../../common/lifetime";
import {GLOBAL} from "../../common/globals";
import {UnLitElement} from "../../common/elements";

const ENABLE_DYNAMIC_BACKGROUND_COLOR_CLASS = "dynamic-background-color";
//color-gradient-background
@customElement("eop-dynamic-background-color")
export class EopDynamicBackgroundColor extends ManagingResources(UnLitElement) {

    public constructor(
        private sections: Sections = resolve(Sections)
    ) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        const main = GLOBAL.bodyElement().querySelector("main")!;
        if (main.classList.contains(ENABLE_DYNAMIC_BACKGROUND_COLOR_CLASS)) {
            this.sections.onSectionChange((section) => this.updateActiveBackground(section), this);
        }
    }

    private updateActiveBackground(activeSection: Section): void {
        this.sections.getSections().forEach(section => {
            this.removeCurrentBackground(section);
            section.element.classList.add(activeSection.staticBackgroundColorClass);
        });
    }

    private removeCurrentBackground(section: Section): void {
        section.element.classList.forEach(className => {
            if (className.startsWith(SECTION_BACKGROUND_CLASS_PREFIX)) {
                section.element.classList.remove(className);
            }
        });
    }
}